<div class="out">
  <div class="line" *ngFor="let color of text_colors;let i = index"  kzLib (click)="selColor(i)">
    {{text_lbls[i]}}: <span class="lbl" [style.color]="color"> {{color}}</span>
  </div>
</div>
